import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import CoreCountsIcon from "@/components/icon/CoreCounts";
import PulseIcon from "@/components/icon/Pulse";
import SlackIcon from "@/components/icon/Slack";
import general from "@/helpers/locales/general";
import table_group from "@/helpers/locales/table_group";

Vue.use(Vuetify);

export default new Vuetify({
  customVariables: ["~/scss/variables.scss"],
  treeShake: true,
  breakpoint: {
    thresholds: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1200
    }
  },
  lang: {
    locales: { general, table_group },
    current: "general"
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#db6015",
        accent: "#efaa8d",
        secondary: "#23356e",
        success: "#2ED68B",
        info: "#2196F3",
        lightwarning: "#F2BB33",
        warning: "#F4964C",
        error: "#ED6F60",
        background: "#F0F3F4",
        primarytext: "#444444",
        secondarytext: "#6e8ca0",
        lighttext: "#C8D1D3",
        darkaccent: "#444444",
        performance: "#6C63FF",
        noteprimary: "#FECA28",
        white: "#ffffff"
      }
    }
  },
  icons: {
    values: {
      core_counts: {
        component: CoreCountsIcon
      },
      pulse: { component: PulseIcon },
      slack: { component: SlackIcon }
    }
  }
});
